export enum TYPES {
    PASSWORD = 'password',
    TEXT = 'text',
}
